export enum RateGroupType {
    SalesRate = 0,
    PurchasingRate = 1
}

export const RateGroupTypeOptions = [
    {
        label: "core.rate_group_type.sales_rate",
        value: RateGroupType.SalesRate,
    },
    {
        label: "core.rate_group_type.purchasing_rate",
        value: RateGroupType.PurchasingRate,
    }
]